import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import { useFormikWizard } from "formik-wizard";
/*
* IMPORTANT!! Always import "setimmediate" on every step/first step
*/
import 'setimmediate';
function Intro() {
  const { errors, touched, handleBlur, handleChange } = useFormikContext();
  return (
    <div>
      
        <h2>Get an estimate of how much you may need to contribute towards your care costs. </h2>
        <p>If you, or someone you know, need care, it is useful to get an idea of what the costs could be if it is arranged by the council. </p>
        <p>This calculator will give you an estimate of how much you may need to pay towards long-term residential care, care in your home or a short stay in a residential home. </p>
        <p>It is a free, confidential and easy-to-use tool for you to use in your own time. Only you will see your results, they will not be saved or shared with anyone else.</p>
        <p>You can find more information on care and support charges and financial assessments on our <a href="https://www.southglos.gov.uk/health-and-social-care/money-information-and-advice/paying-for-your-support/">Funding care and support page.</a></p>
        <div class="alert alert__message alert--state-info">
        <p>If you have high disability related expenditure this may affect your calculation. Please contact the Finance and Benefits Team on <a href="tel:01454 864269">01454 864269</a> or email <a href="mailto:FABTEAM@southglos.gov.uk">FABTEAM@southglos.gov.uk</a>.</p> 
        </div>
        <h3>Before you start</h3>
        <p>To use the calculator you'll need details of:</p>
        <ul>
        <li>your income, from your pensions and benefits</li>
        <li>your savings and investments, such as ISAs and shares</li>
        <li>your essential bills and spending, for example your council tax, rent and mortgage</li>
        </ul>
        <h3>If you have a partner</h3>
        <p>This calculator gives an estimate for an individual single individuals only. Please enter information as a single person not as a couple.  If you are moving into a residential placement, please state your personal income and capital and halve any joint accounts.</p>
        <p>If you would like a financial estimate for care at home and are a member of a couple please contact the Finance and Benefits Team on <a href="tel:01454 864269">01454 864269</a> or email <a href="mailto:FABTEAM@southglos.gov.uk">FABTEAM@southglos.gov.uk</a></p>
        <h3>Home adaptations</h3>
        <p>This calculator does not give an estimate for help with home adaptations. For information on home adaptions visit our <a href="https://find-information-for-adults-children-families.southglos.gov.uk/kb5/southglos/directory/advice.page?id=utLIq1DF89Q&adultchannel=1-1&channel=adult">Adaptations to your home</a> page.</p>
    </div>
  );
}

export default Intro;
